import type { TFunction } from 'i18next';

import yup from '../../../../../shared/validation';

export function getRecordMeasurementFormValidation(t: TFunction) {
  return yup.object({
    unitKey: yup.string().required(t('formikValidation.valueRequired')),
    value: yup
      .number()
      .typeError(t('formikValidation.valueRequired'))
      .required(t('formikValidation.valueRequired'))
      .moreThan(0, t('settings.measurements.valuePositive')),
  });
}
